import { render, staticRenderFns } from "./ActivationSuccess.vue?vue&type=template&id=8a35fa16&scoped=true"
import script from "./ActivationSuccess.vue?vue&type=script&lang=js"
export * from "./ActivationSuccess.vue?vue&type=script&lang=js"
import style0 from "./ActivationSuccess.vue?vue&type=style&index=0&id=8a35fa16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a35fa16",
  null
  
)

export default component.exports